import { useQuery } from '@tanstack/react-query';
import { api } from '@/utils/Api/POS';
import { GetApiDirectWebstorePaymentsParams } from '@/shared/api/models';

export const useDirectWebstorePayments = ({
    params,
    enabled = true,
}: {
    params?: GetApiDirectWebstorePaymentsParams;
    enabled?: boolean;
}) => {
    return useQuery({
        queryKey: ['direct-webstore-payments', params],
        queryFn: () => api.getApiDirectWebstorePayments(params),
        enabled,
        staleTime: 0,
        retry: 1,
    });
};
